export enum DrawerState {
  OPEN = 'open',
  CLOSED = 'closed',
}
